import React, { useEffect, useRef } from 'react';
import '../styles/SuitcaseTheatreArcadeStyle.css';

const CALENDLY_URL = 'https://calendly.com/kyle-hinton/kyle-hinton-meeting';
const CALENDLY_SCRIPT_URL = 'https://assets.calendly.com/assets/external/widget.js';

function Contact() {
    const calendlyContainerRef = useRef(null);

    useEffect(() => {
        const initializeCalendly = () => {
            if (window.Calendly && calendlyContainerRef.current) {
                calendlyContainerRef.current.innerHTML = '';
                window.Calendly.initInlineWidget({
                    url: CALENDLY_URL,
                    parentElement: calendlyContainerRef.current
                });
            }
        };

        const existingScript = document.querySelector(
            `script[src="${CALENDLY_SCRIPT_URL}"]`
        );

        if (existingScript) {
            if (window.Calendly) {
                initializeCalendly();
            } else {
                existingScript.addEventListener('load', initializeCalendly);
            }
        } else {
            const script = document.createElement('script');
            script.src = CALENDLY_SCRIPT_URL;
            script.async = true;
            script.addEventListener('load', initializeCalendly);
            document.body.appendChild(script);
        }

        return () => {
            const script = document.querySelector(
                `script[src="${CALENDLY_SCRIPT_URL}"]`
            );
            script?.removeEventListener('load', initializeCalendly);
        };
    }, []);

    return (
        <main className="contact-page">
            <header className="contact-header fade-in">
                <p className="services-eyebrow">Contact Suitcase Theatre Arcade</p>
                <h1>Let&apos;s plan something together.</h1>
                <p>
                    Choose a meeting time below to discuss your audience, venue,
                    event and the service that would be the best fit.
                </p>
            </header>

            <section className="contact-calendly" aria-labelledby="contact-calendly-title">
                <h2 id="contact-calendly-title">Book a conversation</h2>
                <div
                    ref={calendlyContainerRef}
                    className="contact-calendly-widget"
                    aria-label="Schedule a meeting with Suitcase Theatre Arcade"
                />
            </section>

            <section className="contact-email" aria-labelledby="contact-email-title">
                <div>
                    <p className="services-eyebrow">Prefer email?</p>
                    <h2 id="contact-email-title">Send your booking details directly.</h2>
                </div>
                <a
                    className="services-cta services-cta-light"
                    href="mailto:kyle-hinton@outlook.com?subject=Suitcase%20Theatre%20Arcade%20Booking"
                >
                    Send an email
                </a>
            </section>
        </main>
    );
}

export default Contact;
